import { useCompletedTour } from "@/features/tour//utils";
import {
  type UserTourState,
  type UserTourStateActions,
  UserTourStateCalendar,
  reducer,
  userTourStateActions,
} from "@/features/tour/reducer";
import { useSettings } from "@repo/ui";
import { useTypesafeActions } from "@repo/utils";
import { createContext, useContext } from "react";

import { CalendarTour } from "./CalendarTour";

const UserTourContext = createContext<UserTourState>({} as UserTourState);

export const CalendarTourProvider = ({ children }: React.PropsWithChildren) => {
  const { tourData, isValidating } = useCompletedTour(
    UserTourStateCalendar.currentTour
  );
  const { feature_flags } = useSettings();
  const [state, actions] = useTypesafeActions<
    UserTourState,
    UserTourStateActions
  >(
    reducer,
    {
      ...UserTourStateCalendar,
    },

    userTourStateActions
  );

  return (
    <UserTourContext.Provider value={state}>
      {!isValidating && feature_flags?.calendar_intro && tourData && (
        <CalendarTour state={state} actions={actions} />
      )}
      {children}
    </UserTourContext.Provider>
  );
};

export const useCalendarTour = () => useContext(UserTourContext);
